// removed by extract-text-webpack-plugin
module.exports = {"root":"FilterPopup__root__3iGnM","label":"FilterPopup__label__1JvVD","labelSelected":"FilterPopup__labelSelected__3K95F","labelEllipsis":"FilterPopup__labelEllipsis__6kubM","popup":"FilterPopup__popup__2M1im","popupSize":"FilterPopup__popupSize__1xv02","isOpen":"FilterPopup__isOpen__2LvFC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FilterPopup/FilterPopup.css
// module id = 1817
// module chunks = 0